<!-- DEVICES HEADER -->
<div class="sticky top-0 z-20 flex items-center gap-x-6 bg-gray-800 px-4 py-4 shadow-xs sm:px-6 md:hidden">
  <button type="button" class="-m-2.5 p-2.5 text-gray-400 lg:hidden cursor-pointer" (click)="menuService.toggleMenu()">
    <span class="sr-only">Open sidebar</span>
    <svg class="size-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true" data-slot="icon">
      <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  </button>
  <div class="flex-1 text-sm/6 font-semibold text-white">{{ title }}</div>
  <app-profile id="header"></app-profile>
</div>
